













































































































import Vue from "vue";
import gameProjectsData from "@/data/GameProjectsData";
import ProjectData from "@/data/ProjectData";
import Helpers from "@/helpers";

export default Vue.extend({
  name: "ProjectDetails",
  computed: {
    project(): ProjectData | undefined {
      return gameProjectsData.find(item => item.slug === this.$route.params.slug);
    },
    nextProject(): ProjectData | undefined {
      const currentProject = this.project;
      if (!currentProject) {
        return undefined;
      }

      const featuredProjects = gameProjectsData.filter(item => item.featured);
      const currentIndex = featuredProjects.findIndex(item => item.id === currentProject.id);
      return featuredProjects[(currentIndex + 1) % featuredProjects.length];
    }
  },
  methods: {
    returnToProjects() {
      Helpers.queueSectionScroll("projects");
      this.$router.push("/");
    }
  },
  watch: {
    project: {
      immediate: true,
      handler(project: ProjectData | undefined) {
        if (!project) {
          this.$router.replace('/404');
          return;
        }

        Helpers.updateMetadata(
          `${project.name} — EJ Taylan`,
          project.summary,
          project.iconUrl
        );
      }
    }
  }
});
